import { formatVND } from "utils";

// Số hiển thị trên đầu cột biểu đồ: 224,6tr / 1,25 tỷ; bằng 0 thì không hiện
export const formatBarLabel = (value: number) => {
  const abs = Math.abs(value || 0);
  if (!abs) return "";
  const trim = (num: number, digits: number) => String(+num.toFixed(digits)).replace(".", ",");
  if (abs >= 1_000_000_000) return `${trim(value / 1_000_000_000, 2)} tỷ`;
  if (abs >= 1_000_000) return `${trim(value / 1_000_000, 1)}tr`;
  return formatVND(Math.round(value));
};

// Cấu hình nhãn giá trị cho series dạng cột: position "top" (cột dọc) hoặc "right" (cột ngang)
export const barValueLabel = (position: "top" | "right", fontSize = 11) => ({
  show: true,
  position,
  fontSize,
  formatter: (params: { value: number }) => formatBarLabel(Number(params.value)),
});
